import { SxProps } from '@mui/material';

export const getComponentsStyles = (palette: Record<string, any>) => {
  const componentsStyles: Record<string, any> = {};

  componentsStyles['muiButtonStyleOverride'] = {
    backgroundColor: palette.button?.background.main,
    color: palette.button?.font.main,
    '&:hover': {
      backgroundColor: palette.button?.background.hover,
      color: palette.button?.font.hover
    }
  };

  return componentsStyles;
};

export const getModifierStyles = (): SxProps => {
  return {
    fontWeight: 400,
    fontSize: '14px'
  };
};
